import React, { useEffect, useState } from 'react';
import reactCSS from 'reactcss';
import DateRangePicker from 'react-daterange-picker';
import { Input, InputGroup, InputGroupAddon } from 'reactstrap';
import 'react-daterange-picker/dist/css/react-calendar.css';
import TimePicker from 'react-time-picker';
import moment from 'moment';

const DateAndTime = ({
  name = null,
  value,
  onChange,
  minimumDate = null,
  maximumDate = null,
  isDisable = false
}) => {
  const [date, setDate] = useState(null);
  const [time, setTime] = useState('00:00:00');
  const [selectedDate, setSelectedDate] = useState('');
  const [displayDatePicker, setDisplayDatePicker] = useState(false);

  useEffect(() => {
    if (value) {
      const dt = value.split('T');
      setSelectedDate(moment(dt[0]).format('DD/MM/YYYY'));
      setTime(dt[1]);
    }
  }, [value]);

  const onSelect = (currentDate) => {
    let dateTime = currentDate.format('YYYY-MM-DD') + 'T' + time;
    onChange(dateTime);
    setSelectedDate(currentDate.format('DD/MM/YYYY'));
    setDate(currentDate);
    setDisplayDatePicker(false);
  };

  const handleClick = () => {
    setDisplayDatePicker(!displayDatePicker);
  };

  const handleClose = () => {
    setDisplayDatePicker(false);
  };

  const onChangeTime = (e) => {
    let time = e ? e + ':00' : '00:00:00';
    let dateTime = date
      ? date.format('YYYY-MM-DD') + 'T' + time
      : moment().format('YYYY-MM-DD') + 'T' + time;
    onChange(dateTime);
    setTime(time);
  };

  const styles = reactCSS({
    default: {
      swatch: {
        padding: '5px 10px',
        background: '#fff',
        borderRadius: '3px',
        border: '1px solid #cccccc',
        cursor: 'pointer'
      },
      popover: {
        position: 'absolute',
        background: '#fff',
        border: '1px solid #cccccc',
        borderRadius: '3px',
        marginTop: '45px',
        zIndex: '2'
      },
      cover: {
        position: 'fixed',
        top: '0px',
        right: '0px',
        bottom: '0px',
        left: '0px'
      },
      date: {
        width: '10%',
        background: 'transparent'
      },
      addon: {
        marginRight: '10px'
      }
    }
  });

  return (
    <div style={{ width: '100%' }}>
      <InputGroup>
        <Input
          name={name}
          style={styles.date}
          value={selectedDate || ''}
          readOnly
          onClick={handleClick}
        />

        {displayDatePicker ? (
          <div style={styles.popover}>
            <div style={styles.cover} onClick={handleClose} />
            <DateRangePicker
              onSelect={onSelect}
              value={date || ''}
              selectionType="single"
              minimumDate={minimumDate || null}
              maximumDate={maximumDate || null}
            />
          </div>
        ) : null}

        <InputGroupAddon addonType="append" style={styles.addon}>
          <div style={styles.swatch} onClick={handleClick}>
            <i className="fa fa-calendar"></i>
          </div>
        </InputGroupAddon>

        <TimePicker
          disableClock={true}
          format="HH:mm"
          onChange={onChangeTime}
          disabled={isDisable}
          value={time || ''}
        />
      </InputGroup>
    </div>
  );
};

export default DateAndTime;
